import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import BoardThumbnail, { type BoardThumbnailProps } from '~/components/BoardThumbnail/BoardThumbnail';
import { getPreferenceImgixFit, useThumbnailPreference } from '~/hooks/useThumbnailPreference';
import { CentralizedBoardSelectors } from '~/store/centralizedBoard/selectors';

export type BoardGalleryCardThumbnailProps = Pick<BoardThumbnailProps, 'board' | 'height' | 'sizes'>;

export const BoardGalleryCardThumbnail = memo(({ board, height, sizes }: BoardGalleryCardThumbnailProps) => {
  const { getPreference } = useThumbnailPreference();
  const boardId = useSelector(CentralizedBoardSelectors.boardId);
  const thumbnailPreference = useMemo(() => getPreference(boardId), [boardId, getPreference]);

  return (
    <BoardThumbnail
      board={board}
      objectFit={thumbnailPreference === 'default' ? 'cover' : 'contain'}
      imgixParams={{
        fit: getPreferenceImgixFit(thumbnailPreference),
      }}
      height={height}
      sizes={sizes}
      width="100%"
    />
  );
});

BoardGalleryCardThumbnail.displayName = 'BoardGalleryCardThumbnail';
